<template>
  <iRow
    :class="{
      'color-indicator': true,
    }"
    :width="hasTitleOrSubtitle?'fill':'hug'"
    gap="standard"
    vertical-align="middle"
    wrap="nowrap"
  >
    <div
      v-if="typeof color === 'object'"
      :class="swatchClasses"
    >
      <div class="inner-swatch-border">
        <div :style="`border-top-color: ${color[CONTRAST_LIGHT_MODE]}`" class="color-swatch-light-mode" />
        <div :style="`border-bottom-color: ${color[CONTRAST_DARK_MODE]}`" class="color-swatch-dark-mode" />
      </div>
    </div>
    <div
      v-else
      :class="swatchClasses"
      :style="`background-color: ${color}`"
    />
    <iColumn v-if="hasTitleOrSubtitle" gap="none" vertical-align="middle">
      <iText v-if="showTitle" font-size="small">
        {{ camelToTitleCase(title) }}
      </iText>
      <iText v-if="showSubtitle" font-size="verySmall" variant="subtle">
        {{ subtitle }}
      </iText>
    </iColumn>
  </iRow>
</template>

<script>
import { camelToTitleCase } from "@bloglovin/vue-framework";
import { CONTRAST_LIGHT_MODE, CONTRAST_DARK_MODE } from "~/constants/color-palette-editor-constants";

export default {
  name: "ColorSwatch",
  props: {
    color: {
      type: [String, Object],
      required: false,
      default: "#ffffff",
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    subtitle: {
      type: String,
      required: false,
      default: "",
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: false,
    },
    showSubtitle: {
      type: Boolean,
      required: false,
      default: false,
    },
    asButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    activeGroup: {
      type: Boolean,
      required: false,
      default: false,
    },
    width: {
      type: Number,
      required: false,
      default: 32,
    },
  },
  data() {
    return {
      CONTRAST_LIGHT_MODE,
      CONTRAST_DARK_MODE,
    };
  },
  computed: {
    myWidth() {
      return `${this.width}px`;
    },
    swatchClasses() {
      return { "color-swatch": true, "active": this.isActive, "clickable": this.asButton, "active-group": this.activeGroup };
    },
    hasTitleOrSubtitle() {
      let hasTitle = this.showTitle && this.title;
      let hasSubtitle = this.showSubtitle && this.subtitle;
      return hasTitle || hasSubtitle;
    },
  },
  methods: { camelToTitleCase },
  styleGuide: () => ({
    borderColor: { "color.border": "standard" },
    selectedBorderColor: { "color.border": "dark" },
    selectedBorderWidth: { "size.border": "thick" },
    borderWidth: { "size.border": "thick" },
  }),
};
</script>

<style lang="scss" scoped>
.color-swatch {
  width: v-bind("myWidth");
  height: v-bind("myWidth");
  border-radius: 4px;
  outline: grey solid 1px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;

  &-light-mode {
    position: absolute;
    border-top: v-bind("myWidth") solid pink;
    border-right: v-bind("myWidth") solid transparent;
    height: 0;
    width: 0;
  }

  &-dark-mode {
    position: absolute;
    border-bottom: v-bind("myWidth") solid red;
    border-left: v-bind("myWidth") solid transparent;
    height: 0;
    width: 0;
  }
}

.clickable {
  cursor: pointer;
  margin-inline: 2px;

  &:not(.active-group) {
    border: 1px solid grey;
    outline: 2px solid transparent;

    &:hover {
      outline: 2px solid black;
    }
  }

  &.active-group {
    border: 1px solid grey;
    outline: 2px solid transparent;

    &:hover {
      border: 1px solid black;
      outline: 2px solid grey;
    }

    &.active {
      border: 1px solid grey;
      outline: 2px solid black;
    }
  }
}

.color-indicator:has(.color-swatch:not(.clickable)) .active {
  outline: black solid 2px;
}

</style>
